<template>

<div class="card mb-3">
        <div class="card-body">

        <div class="row">
          <div class="col"><div class="pb-2"><b class="mr-3">Delivery address</b><small><a href="#/" @click="openAddresses" style="color:#0b79bf;">Change</a></small></div></div>
        </div>

        <div class="receiver">{{address.receiver_name}} {{address.receiver_phone}}</div>
        <div>
          <span v-if="address.building">{{address.building}}, </span>
          <span v-if="address.unit_number">{{address.unit_number}}, </span>
          <span v-if="address.street_address">{{address.street_address}}, </span>
          <span v-if="address.business_name">{{address.business_name}}, </span>
          <span v-if="address.suburb">{{address.suburb}}, </span>
          <span v-if="address.city">{{address.city}}, </span>
          <span v-if="address.province">{{address.province}}, </span>
          <span v-if="address.postal_code">{{address.postal_code}}</span>
        </div>
        </div>
        </div>

</template>

<script>
export default {
  props: ['address'],
  data() {
    return {
    };
  },

  created() {
    
  },

  methods: {

    openAddresses() {
      this.$emit('open-addresses');
    },

    },
};
</script> 
